var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF7AC9","fillRule":"nonzero","d":"M7.705.293l4.002 4.002a1 1 0 0 1 0 1.414L7.705 9.711A1 1 0 1 1 6.29 8.297L8.585 6H1a1 1 0 1 1 0-2h7.585L6.291 1.707A1 1 0 1 1 7.705.293z"}));
}

Arrow.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10"};

module.exports = Arrow;

Arrow.default = Arrow;
